import React, { useEffect, createElement } from 'react';
export function AccessPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-550">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-551">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-552">
          AI <span className="text-[#F5C842]" data-id="element-553">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-554">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-555">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-556">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-557">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-558">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-559">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-560">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-561">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-562">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-563">
            Módulo 1 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-564">
            ⏱ 15 minutos · Nivel: Principiante
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-565">
          El Mercado
          <br data-id="element-566" />
          de <span className="text-[#F5C842]" data-id="element-567">Oro</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-568">
          Cómo identificar los negocios locales con mayor urgencia de tener un
          sitio web y mayor disposición a pagar — en menos de 15 minutos.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-569">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-570">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-571"></div>
            Google Maps como herramienta de prospección
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-572">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-573"></div>6
            nichos de alta conversión
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-574">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-575"></div>
            Tarea de acción inmediata
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-576">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-577">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-578">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-579"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-580">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-581">
              <iframe src="https://player.vimeo.com/video/1179701690?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSE - VID 1" data-id="element-582" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 1 */}
        <div className="mt-4 mb-10" data-id="element-583">
          <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-584">
            <span className="text-[20px]" data-id="element-585">🧠</span>
            Abrir Ai Website Arbitrage en Heylloyd
            <span className="text-[18px] font-black" data-id="element-586">→</span>
          </a>
        </div>

        {/* WHAT YOU'LL LEARN */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-587">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-588">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-589">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-590"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-591">
                Lo que aprenderás
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-592">
              Cómo identificar los negocios locales con{' '}
              <strong className="text-white" data-id="element-593">mayor urgencia</strong> de tener un
              sitio web y mayor disposición a pagar. Aprenderás a ver el mercado
              que te rodea como un mapa de oportunidades — cada negocio sin
              sitio web es una oportunidad de{' '}
              <strong className="text-white" data-id="element-594">$350</strong>.
              <br data-id="element-595" />
              <br data-id="element-596" />
              Tu trabajo no es convencerlos de que necesitan un sitio web. Tu
              trabajo es{' '}
              <strong className="text-white" data-id="element-597">
                mostrarles lo que están perdiendo sin uno
              </strong>
              .
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-598">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-599">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-600"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-601">
                La oportunidad real
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-602">
              <ul className="flex flex-col" data-id="element-603">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-604">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-605">
                    →
                  </span>
                  Millones de negocios locales no tienen sitio web
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-606">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-607">
                    →
                  </span>
                  Muchos tienen sitios que parecen hechos en 2005
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-608">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-609">
                    →
                  </span>
                  Ellos necesitan tu ayuda y están dispuestos a pagar
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-610">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-611">
                    →
                  </span>
                  Cada negocio sin sitio = oportunidad de $350
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-612">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-613">
                    →
                  </span>
                  Hay miles de esas oportunidades en tu ciudad ahora mismo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* NICHES */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-614">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-615"></span>
          Los 6 Mejores Nichos para Empezar
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-3" data-id="element-616">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-617">
            <div className="mb-2 text-[28px]" data-id="element-618">🍽️</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-619">
              Restaurantes
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-620">
              Alta búsqueda local en Google. Clientes activos que buscan menú y
              horarios online.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-621">
            <div className="mb-2 text-[28px]" data-id="element-622">✂️</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-623">
              Peluquerías
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-624">
              Necesitan reservas online. Días entre semana vacíos que un sitio
              puede llenar.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-625">
            <div className="mb-2 text-[28px]" data-id="element-626">🔧</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-627">
              Talleres
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-628">
              Clientes buscan mecánicos en Google antes de llamar. Sin sitio =
              invisible.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-629">
            <div className="mb-2 text-[28px]" data-id="element-630">🦷</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-631">
              Dentistas
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-632">
              Alto valor por cliente. Buscan diferenciarse de la competencia con
              presencia digital.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-633">
            <div className="mb-2 text-[28px]" data-id="element-634">👗</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-635">
              Tiendas Locales
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-636">
              Compiten contra Amazon. Un sitio les da visibilidad local que las
              grandes no tienen.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-4 py-[18px] text-center transition-colors hover:border-[#F5C842]" data-id="element-637">
            <div className="mb-2 text-[28px]" data-id="element-638">🏠</div>
            <div className="mb-1 font-heading text-[12px] font-black text-white" data-id="element-639">
              Servicios del Hogar
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-640">
              Plomeros, limpieza, electricistas. Alta demanda, poca competencia
              digital local.
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-641">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-642">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-643"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-644">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-645">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-646"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-647">
              "Bienvenido al Módulo 1 de AI Web Closer. En los próximos 15
              minutos, voy a mostrarte algo que va a cambiar completamente cómo
              ves el mercado que te rodea. Cuando termines este módulo, vas a
              salir a la calle y ver dinero en cada esquina. Empecemos."
            </div>
          </div>

          <div className="mb-4" data-id="element-648">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-649">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-650"></span>⏱
              0:30 – 10:00 · Contenido Principal
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-651">
              "Quiero que hagas algo ahora mismo. Abre Google Maps en tu
              teléfono y busca cualquier tipo de negocio en tu ciudad. Puede ser{' '}
              <span className="not-italic text-[#666]" data-id="element-652">
                'peluquerías en [tu ciudad]'
              </span>{' '}
              o{' '}
              <span className="not-italic text-[#666]" data-id="element-653">
                'restaurantes en [tu ciudad]'
              </span>
              . ¿Lo ves? Hay decenas, quizás cientos de resultados. Ahora haz
              clic en 3 de esos negocios al azar y busca si tienen un sitio web.
              Apuesto a que al menos uno de los tres no tiene sitio, o tiene uno
              que parece hecho en 2005."
              {'\n\n'}
              "Eso que acabas de encontrar es una oportunidad de $350. Y hay
              miles de esas oportunidades en tu ciudad ahora mismo."
              {'\n\n'}
              "Los mejores nichos para empezar son: restaurantes y cafeterías,
              peluquerías y barberías, talleres mecánicos, dentistas y médicos
              locales, tiendas de ropa o accesorios, y servicios de limpieza o
              plomería. ¿Por qué estos? Porque tienen clientes locales que los
              buscan en Google, y si no aparecen con un sitio profesional,
              pierden esos clientes a la competencia."
              {'\n\n'}
              "Tu trabajo no es convencerlos de que necesitan un sitio web. Tu
              trabajo es mostrarles lo que están perdiendo sin uno. Y para eso,
              vamos a usar el cerebro de IA en el Módulo 2."
            </div>
          </div>

          <div className="mb-4" data-id="element-654">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-655">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-656"></span>⏱
              10:00 – 15:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-657">
              "Tu tarea para este módulo es simple: haz una lista de 10 negocios
              locales en tu ciudad que no tengan sitio web o que tengan uno muy
              malo. Solo 10. Puedes hacerlo en 15 minutos con Google Maps.
              Cuando tengas tu lista, pasa al Módulo 2. Nos vemos ahí."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-658">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-659">
            ✅ Tu Tarea — Módulo 1
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-660">
            Haz una lista de{' '}
            <strong className="text-white" data-id="element-661">10 negocios locales</strong> en tu
            ciudad que no tengan sitio web o que tengan uno muy malo. No pases
            al Módulo 2 sin completar esta tarea.
            <div className="mt-3 flex flex-col gap-2" data-id="element-662">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-663">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-664">
                  1
                </div>
                Abre Google Maps en tu teléfono o computadora
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-665">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-666">
                  2
                </div>
                Busca un tipo de negocio en tu ciudad (ej: "peluquerías en
                Miami")
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-667">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-668">
                  3
                </div>
                Revisa cuáles no tienen sitio web o tienen uno muy viejo
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-669">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-670">
                  4
                </div>
                Guarda: nombre del negocio, teléfono y tipo de negocio
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-671">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-672">
                  5
                </div>
                <strong className="text-white" data-id="element-673">
                  Repite hasta tener 10 negocios en tu lista
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-674">
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-675">
          AI <span className="text-[#F5C842]" data-id="element-676">WEB CLOSER</span>
        </div>
        <div className="flex items-center gap-4" data-id="element-677">
          <a href="/modulo-0" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-678">
            ← Módulo 0
          </a>
          <a href="/modulo-2" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-679">
            Módulo 2: El Cerebro Cazador →
          </a>
        </div>
      </div>
    </div>;
}